var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0151 2.90997C8.70644 2.90997 6.01754 5.59997 6.01754 8.90997V11.8C6.01754 12.41 5.75765 13.34 5.44777 13.86L4.29825 15.77C3.58854 16.95 4.07834 18.26 5.3778 18.7C9.68604 20.14 14.3341 20.14 18.6424 18.7C19.8519 18.3 20.3817 16.87 19.7219 15.77L18.5724 13.86C18.2725 13.34 18.0126 12.41 18.0126 11.8V8.90997C18.0126 5.60997 15.3137 2.90997 12.0151 2.90997Z",
    stroke: "#8F93AE",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8643 3.2C13.5544 3.11 13.2345 3.04 12.9047 3C11.945 2.88 11.0254 2.95 10.1658 3.2C10.4557 2.46 11.1754 1.94 12.015 1.94C12.8547 1.94 13.5744 2.46 13.8643 3.2Z",
    stroke: "#8F93AE",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0139 19.06C15.0139 20.71 13.6645 22.06 12.0151 22.06C11.1955 22.06 10.4358 21.72 9.896 21.18C9.35622 20.64 9.01636 19.88 9.01636 19.06",
    stroke: "#8F93AE",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.c96c4fe635814502c40226cdf859a471.svg";
export { ForwardRef as ReactComponent };